import React, {useState} from "react";
import {useAuth} from "../context/AuthContext";
import {Box, IconButton, Menu, MenuItem} from "@mui/material";
import {
    ExitToApp as LogoutIcon,
    Settings as SettingsIcon
} from '@mui/icons-material';

export const UserMenu: React.FC = () => {

    const { logout } = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleLogout = async (): Promise<void> => {
        await logout();
    };

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton
                size="large"
                edge="end"
                onClick={handleMenuOpen}
                color="inherit"
            >
                <SettingsIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                disableScrollLock={true}
                PaperProps={{
                    elevation: 3,
                    sx: { mt: 1.5, minWidth: 200 }
                }}
            >
                <MenuItem onClick={handleLogout}>
                    <LogoutIcon sx={{ mr: 1 }} />
                    Logout
                </MenuItem>
            </Menu>
        </Box>
    );
};